<section class="tracker-page">
  <header class="tracker-header">
    <div>
      <h1>Meine Trades Tracker</h1>
      <p>Kalenderübersicht für eröffnete Trades und deren Ergebnisse.</p>
    </div>
    <button type="button" class="secondary" (click)="refresh()">Aktualisieren</button>
  </header>

  <nav class="sheet-tabs" aria-label="Tracker Sheets">
    <button type="button" [class.active]="activeSheet === 'opened'" (click)="setSheet('opened')">Eröffnet</button>
    <button type="button" [class.active]="activeSheet === 'results'" (click)="setSheet('results')">Ergebnis</button>
  </nav>

  <div class="tracker-toolbar">
    <div class="month-controls">
      <button type="button" class="ghost" (click)="previousMonth()" aria-label="Vorheriger Monat">‹</button>
      <select [(ngModel)]="month">
        <option *ngFor="let label of months; let index = index" [ngValue]="index">{{ label }}</option>
      </select>
      <select [(ngModel)]="year">
        <option *ngFor="let option of [year - 2, year - 1, year, year + 1, year + 2]" [ngValue]="option">{{ option }}</option>
      </select>
      <button type="button" class="ghost" (click)="nextMonth()" aria-label="Nächster Monat">›</button>
      <button type="button" class="secondary" (click)="goToday()">Heute</button>
    </div>

    <div class="month-kpi" *ngIf="activeSheet === 'opened'; else resultKpi">
      <span>Trades: <strong>{{ monthOpenedTotal().trades.length }}</strong></span>
      <span>Volumen: <strong>{{ monthOpenedTotal().volume | number:'1.2-2' }} €</strong></span>
      <span>Risiko: <strong>{{ monthOpenedTotal().risk | number:'1.2-2' }} €</strong></span>
    </div>
    <ng-template #resultKpi>
      <div class="month-kpi">
        <span [ngClass]="statusClass(monthResultTotal().r)">Σ G&V: <strong>{{ monthResultTotal().r | number:'1.2-2' }}R</strong></span>
        <span>Transaktionen: <strong>{{ monthResultTotal().items.length }}</strong></span>
        <span *ngIf="monthResultTotal().items.length">Euro: <strong [ngClass]="statusClass(monthResultTotal().pnl)">{{ monthResultTotal().pnl | number:'1.2-2' }} €</strong></span>
      </div>
    </ng-template>
  </div>

  <div class="calendar" [attr.aria-label]="sheetTitle()">
    <div class="weekday" *ngFor="let day of weekDays">{{ day }}</div>
    <button
      type="button"
      class="day"
      *ngFor="let day of calendarDays()"
      [class.outside]="!day.inMonth"
      [class.today]="day.isToday"
      [class.selected]="selectedDate === day.date"
      (click)="selectedDate = day.date"
    >
      <span class="day-number">{{ day.day }}</span>

      <ng-container *ngIf="activeSheet === 'opened'; else resultDay">
        <ng-container *ngIf="openedSummary(day.date) as summary">
          <div class="day-panel" *ngIf="summary.trades.length">
            <div class="bar is-neutral">Eröffnet: <strong>{{ summary.trades.length }}</strong></div>
            <div>Volumen: <strong>{{ summary.volume | number:'1.2-2' }} €</strong></div>
            <div>Risiko: <strong>{{ summary.risk | number:'1.2-2' }} €</strong></div>
          </div>
        </ng-container>
      </ng-container>

      <ng-template #resultDay>
        <ng-container *ngIf="resultSummary(day.date) as summary">
          <div class="day-panel" *ngIf="summary.items.length">
            <div class="bar" [ngClass]="statusClass(summary.r)">G&V: <strong>{{ summary.r | number:'1.2-2' }}R</strong></div>
            <div>Euro: <strong [ngClass]="statusClass(summary.pnl)">{{ summary.pnl | number:'1.2-2' }} €</strong></div>
            <div>Transaktionen: <strong>{{ summary.items.length }}</strong></div>
          </div>
        </ng-container>
      </ng-template>
    </button>
  </div>

  <section class="detail">
    <header>
      <h2>{{ selectedDate | date:'dd.MM.yyyy' }} · {{ sheetTitle() }}</h2>
    </header>

    <ng-container *ngIf="activeSheet === 'opened'; else resultDetails">
      <div class="detail-empty" *ngIf="!selectedOpened().trades.length">Keine eröffneten Trades an diesem Tag.</div>
      <div class="detail-list" *ngIf="selectedOpened().trades.length">
        <article class="detail-card" *ngFor="let trade of selectedOpened().trades">
          <div>
            <strong>{{ trade.symbol }}</strong>
            <span>{{ shortStatus(trade.status) }} · {{ trade.direction }} · {{ trade.setup }}</span>
          </div>
          <div>Entry: <strong>{{ trade.entryPrice | number:'1.2-2' }}</strong></div>
          <div>Stop: <strong>{{ trade.stopPrice | number:'1.2-2' }}</strong></div>
          <div>Ziel: <strong>{{ trade.targetPrice | number:'1.2-2' }}</strong></div>
          <div>Stück: <strong>{{ trade.size }}</strong></div>
          <div>Risiko: <strong>{{ initialRiskTotal(trade) | number:'1.2-2' }} €</strong></div>
        </article>
      </div>
    </ng-container>

    <ng-template #resultDetails>
      <div class="detail-empty" *ngIf="!selectedResults().items.length">Keine realisierten Ergebnisse an diesem Tag.</div>
      <div class="detail-list" *ngIf="selectedResults().items.length">
        <article class="detail-card" *ngFor="let item of selectedResults().items">
          <div>
            <strong>{{ item.trade.symbol }}</strong>
            <span>{{ item.label }} · {{ item.trade.direction }} · {{ item.trade.setup }}</span>
          </div>
          <div>Preis: <strong>{{ item.price ?? 0 | number:'1.2-2' }}</strong></div>
          <div>Stück: <strong>{{ item.size }}</strong></div>
          <div>Euro: <strong [ngClass]="statusClass(item.pnl)">{{ item.pnl | number:'1.2-2' }} €</strong></div>
          <div>R: <strong [ngClass]="statusClass(item.r)">{{ item.r | number:'1.2-2' }}R</strong></div>
        </article>
      </div>
    </ng-template>
  </section>
</section>
